import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {MandantenService} from '../mandanten/mandanten.service';

@Injectable()
export class StateService {

  public mandant: BehaviorSubject<any> = new BehaviorSubject<any>(false)

  constructor(
    public mandant_service: MandantenService
  ) {}

  checkMandant(mandant) {
    let key = Object.keys(mandant.registrierFormen)
    return mandant.registrierFormen[key[0]].registrierArt == 1;
  }


  registerButton(mandant): boolean{
    if (mandant.mailerAktiv){
      return mandant.darstellungRegistrierung == '1' || (mandant.darstellungRegistrierung == '2')
    }else{
      return mandant.darstellungRegistrierung == '2' && this.checkMandant(mandant)
    }
  }
}
